import React, { useMemo } from "react";
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {Cancel} from '@mui/icons-material';
import styled from "styled-components";
import { get } from "lodash";
import { useDispatch } from "react-redux";
import usePopUpAtOnce from "components/hooks/usePopUpAtOnce";
import { useUserProfileConfig } from "store/users/selectors";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";

const SentenceStarterOption = ({
  handleUpdateOpenPopUp,
  currentUser,
  savedLesson,
  sharedLesson,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const isCanvasUser = !!get(currentUser, "canvas_id");
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const showAlert = useAlert();

  const hasErrorInContent = useMemo(() => {
    const content = savedLesson?.starter_content || "";
    if (!content || typeof content !== 'string') return false;
    const cleanedContent = content.toLowerCase();
    
    const hasSorryError = cleanedContent.includes("i'm sorry") && 
                         (cleanedContent.includes("can't assist") || cleanedContent.includes("cannot assist"));
    
    const hasUnableToAnalyze = cleanedContent.includes("unable to analyze") || 
                               cleanedContent.includes("i'm unable to analyze");
    
    const hasGeneralTopicError = cleanedContent.includes("can help generate sentence starters based on a general topic") ||
                                 cleanedContent.includes("please provide a topic");
    
    return hasSorryError || hasUnableToAnalyze || hasGeneralTopicError;
  }, [savedLesson?.starter_content]);

  const isButtonDisabled = useMemo(() => {
    return !savedLesson ||
           !savedLesson.id ||
           (typeof savedLesson === "object" &&
             Object.keys(savedLesson).length === 0) ||
           hasErrorInContent;
  }, [savedLesson, hasErrorInContent]);

  return (
    <div
      className="superLessionModal"
    >
      <ModalSuperPlane
        style={{ zIndex: 12 }}
        className="DifferentiationLessionContents sentenceStarterOption sentence-starter-modal-container"
      >
        <span
          onClick={() => {
            handleUpdateOpenPopUp({}, "set");
            updatePopUpAtOnce(false);
          }}
        >
          <Cancel
            style={{
              position: "absolute",
              right: -7,
              top: -7,
              fontSize: 22,
              color: "red",
              background: "white",
              borderRadius: 20,
              cursor: "pointer",
            }}
          />
        </span>
        <Button
          className={classes.disabledButton}
          onClick={() => {
            handleUpdateOpenPopUp(
              {
                type: "sharedSentenceStarter",
                open: true,
                confirmationDialog: false,
              },
              "set"
            );
          }}
          disabled={sharedLesson?.length === 0}
          style={{ opacity: sharedLesson?.length === 0 ? 0.6 : 1 , whiteSpace: "noWrap"}}
        >
          See received sentence starter
        </Button>
        <Button
          className={classes.disabledButton}
          onClick={() => {
            handleUpdateOpenPopUp(
              {
                type: "savedSentenceStarter",
                open: true,
                confirmationDialog: false,
              },
              "set"
            );
          }}
          disabled={isButtonDisabled}
          style={{
            opacity: isButtonDisabled ? 0.6 : 1,
          }}
        >
          See saved sentence starter
        </Button>
        <Button
          onClick={() => {
            if (!isAiPermissionEnabled) {
              showAlert("Please enable AI permission to create sentence starter.", "error");
              return;
            }
            handleUpdateOpenPopUp(
              {
                open: true,
                type: "createSentenceStarterForm",
                confirmationDialog: false,
              },
              "set"
            );
          }}
        >
          Create new sentence starter
        </Button>
      </ModalSuperPlane>
    </div>
  );
};

export default SentenceStarterOption;

const ModalSuperPlane = styled.div`
  align-items: center;
  background-color: #000f4c;
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 320px !important;
  padding: 24px 28px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;

// end Super-lession css

const useStyles = makeStyles({
  disabledButton: {
    color: "white", // Text color when disabled
    "&.Mui-disabled": {
      color: "white", // Ensures the color remains white even if the button is disabled
    },
  },
});